<template>
  <div>
    <v-app id="inspire">
      <v-container fluid style="min-height: 0;" grid-list-lg text-xs-center>
        <v-layout row wrap>
          <v-flex xl12>
            <v-stepper v-model="e1" style="background-color: transparent">
              <v-stepper-header style="display:none">
                <v-stepper-step step="1">Name of step 1</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">Name of step 2</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Name of step 3</v-stepper-step>
              </v-stepper-header>
              <v-stepper-content step="1" style="padding: 0px; height: 500px;">
                <v-flex xs12 style="padding: 0px;">
                  <h3 style="text-align:center; margin: 0px !important;">
                    <span style="color: rgba(0,0,0,1)">
                      <font face="verdana">
                        <span style="color: rgba(0,0,0,1); font-weight:bold;">Schedule</span>
                      </font>
                    </span>
                  </h3>
                  <div>
                    <p style="text-align:center; margin: 0px !important;">
                      <img
                        src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0001.jpg"
                        style="width:100%; height: 450px;"
                      />
                    </p>
                  </div>
                </v-flex>

                <v-fab-transition>
                  <v-btn
                    :href="schedulePDF"
                    target="_blank"
                    class="grey"
                    fixed
                    dark
                    bottom
                    left
                    fab
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 2" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="2" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0002.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 3" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 1" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="3" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0003.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 4" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 2" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="4" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0004.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 5" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 3" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="5" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0005.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 6" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 4" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="6" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0006.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 7" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 5" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="7" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0007.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 8" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 6" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="8" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0008.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 9" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 7" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="9" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0009.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 10" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 8" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="10" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0010.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 11" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 9" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="11" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0011.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 12" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 10" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="12" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0012.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 13" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 11" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="13" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0013.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 14" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 12" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
              <v-stepper-content step="14" style="height: 500px; padding: 0px;">
                <div>
                  <p style="text-align:center; margin: 0px !important;">
                    <img
                      src="/static/pdf/FINAL-54th Amartithi Program 2023_page-0014.jpg"
                      style="width:100%; height: 500px;"
                    />
                  </p>
                </div>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 1" class="pink" fixed dark bottom right fab>
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition>
                  <v-btn @click.native="e1 = 13" class="pink" fixed dark bottom left fab>
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-stepper-content>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>

<script>
// import firebase from 'firebase'
export default {
  data () {
    return {
      e1: 0,
      schedulePDF: 'https://avatarmeherbabatrust.org/wp-content/uploads/2023/01/54th-Amartithi-2023-Program-Schedule.pdf'
    }
  },
  created () {
    // firebase.storage().ref().child('FINAL-51st Amartithi Program 2020.pdf').getDownloadURL().then(url => {
    //   this.schedulePDF = url
    // })
  },
  methods: {}
}
</script>
<style>
p {
  color: black;
  font-weight: bold;
}
.application--light {
  background: transparent;
  color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
}
#bio {
  background-image: linear-gradient(
      rgba(218, 255, 199, 0.8),
      rgba(218, 255, 199, 0.8)
    ),
    url("/static/doc-images/lists/biobg.png");
  overflow: hidden;
  padding: 5px;
  background-size: cover;
}
.application--light .card {
  background-color: rgb(250, 235, 215) !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
#app {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// amartithi-schedule.vue?0718e196